import { Game } from "../Game";
import { SmoothValue } from "../Utils/SmoothValue";
import { Ball, eKickOffResult, eBallState } from "./Player/Ball";
import { Stadium } from "./Stadium/Stadium";
import { Gameplay, TIMER } from "./Gameplay";
import { Shooter } from "./Player/Shooter";



const enum eCameraState {
    idle,
    followBall,
}



export class GameCamera {
    private static readonly DEF_Y = 3.5;
    private static readonly FOLLOW_MIN_DISTANCE = 4;

    static get instance(): GameCamera { return GameCamera._instance; }
    private static _instance: GameCamera;

    private _state: eCameraState;
    private _stateTime: number;
    private _stateProcessFnc: (() => void)[];

    get entity(): pc.Entity { return this._entity; }
    private _entity: pc.Entity;

    private _ball: Ball;

    /**
     * Vektor pohybu pri sledovani mice kamerou
     */
    private _followVec = new pc.Vec3();
    /**
     * Rychlost letu kamery pri sledovani mice v jednotkach za vterinu
     */
    private _followSpeed: SmoothValue = new SmoothValue();
    private _followInitPos = new pc.Vec3();
    /**
     * Rotrace kamery pri zahajeni sledovani mice
     */
    private _followInitRotation: pc.Quat = new pc.Quat();
    /**
     * True, pokud je pozadovano zastaveni kamery, ale kamera jeste neurazila minimalni vzdalenost
     */
    private _followStopReq: boolean;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        GameCamera._instance = this;

        this._entity = Game.camera;

        this._entity.camera.clearColor.fromString("#1E1E1EFF");
        this._entity.camera.cullFaces = true;

        // Zachytavat udalosti mice
        let events = Gameplay.instance.events;

        events.on(Ball.EVENT_KICKED_OFF2, this.handleBallKickedOff, this);
        events.on(Ball.EVENT_FLIGHT_END, this.handleBallFlightEnd, this);

        // Zpracovani stavu kamery
        this._stateProcessFnc = [];
        this._stateProcessFnc[eCameraState.followBall] = this.processFollowBall;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        if (!this._ball)
            this._ball = Ball.instance;

        // Vypocitat pozice mezi micem a hracem, ktera se pouzije jako origin point pro pozici kamery
        let ballPos = this._ball.entity.getPosition();
        let plPos = Shooter.instance.pos;
        let dir = Math.atan2(ballPos.z - plPos.z, ballPos.x - plPos.x);
        let dis = Math.sqrt(Math.pow(plPos.x - ballPos.x, 2) + Math.pow(plPos.z - ballPos.z, 2)) * 0.5;
        let originPos = new pc.Vec3(plPos.x + Math.cos(dir) * dis, 0, plPos.z + Math.sin(dir) * dis);

        // Vypocitat smer a vzdalenost origin point od horiz. stredu branky        
        dir = Math.atan2(Stadium.END_Z - originPos.z, originPos.x - Stadium.CENTER_X);
        dis = Math.sqrt(Math.pow(originPos.x - Stadium.CENTER_X, 2) + Math.pow(originPos.z - Stadium.END_Z, 2)) + 7;

        // Umistit a natocit kameru
        this._followInitPos.set(Stadium.CENTER_X + Math.cos(dir) * dis, GameCamera.DEF_Y, Stadium.END_Z - Math.sin(dir) * dis)
        this._entity.setPosition(this._followInitPos);
        this._entity.lookAt(Stadium.CENTER_X, -1, Stadium.END_Z);
        //this._entity.setPosition(10, 2, -40);
        //this._entity.setEulerAngles(0, 60, 0);

        this._state = eCameraState.idle;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        let fnc = this._stateProcessFnc[this._state];

        if (fnc)
            fnc.call(this);
    }

    //-------------------------------------------------------------------------
    /**
     * Zpracovat vykopnuti mice
     */
    //-------------------------------------------------------------------------
    private handleBallKickedOff(): void {
        // Zahajit sledovani mice kamerou
        this._state = eCameraState.followBall;
        this._stateTime = TIMER.time;

        this._followSpeed.value = 0;
        this._followSpeed.valueStateTag = 0;
        this._followSpeed.startChange(TIMER.time, 9, pc.SineIn, 500);

        this._followInitRotation.copy(this._entity.getRotation());

        this._followVec.set(this._ball.moveVector.x, 0, this._ball.moveVector.z);
        this._followStopReq = false;
    }

    //-------------------------------------------------------------------------
    /**
     * Zpracovat nastaveni vysledku vykopnuti mice
     */
    //-------------------------------------------------------------------------
    private handleBallFlightEnd(): void {
        this.stopCameraFollow();
    }

    //-------------------------------------------------------------------------
    /**
     * Zkontroluje vzdalenost pohybu kamery a pokud je dostatecna, tak plynule zastavi kameru. Pokud neni, tak nastavi pozadavek na zastaveni
     */
    //-------------------------------------------------------------------------
    private stopCameraFollow(): void {
        // Overit dosazeni minimalni vzdalenosti
        if (this._followSpeed.valueStateTag == 0) {
            if (this._followInitPos.distance(this._entity.getPosition()) >= GameCamera.FOLLOW_MIN_DISTANCE) {
                // Plynule zastavit pohyb kamery
                this._followSpeed.valueStateTag = 1;
                this._followSpeed.startChange(TIMER.time, 0, pc.SineIn, 500);

                this._followStopReq = false;
            }
            else {
                this._followStopReq = true;
            }
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private processFollowBall(): void {
        //let ballPos = this._ball.entity.getPosition();
        let speed = this._followSpeed.update(TIMER.time) * TIMER.deltaS;

        if (speed != 0) {
            // Nastavit pozici kamery            
            let pos = this._entity.getPosition();

            pos.x += this._followVec.x * speed;
            pos.z += this._followVec.z * speed;

            this._entity.setPosition(pos);

            if (this._followSpeed.valueStateTag == 0) {
                if (this._followStopReq) {
                    this.stopCameraFollow();
                }
                else if (pos.z < Stadium.END_Z + 15) {
                    this.stopCameraFollow();
                }
            }
        }
    }
}